import angular from "angular";

angular
    .module('core.data', [])
    .service('Data', ['$http', function ($http) {

        this.getOrganizations = function (search) {
            return $http.get('/data/get-organizations', {
                params: {
                    search: search
                }
            }).then(
                function (response) {
                    return response.data.organizations;
                },
                function (error) {

                }
            )
        };

        this.getUsers = function (search) {
            return $http.get('/data/get-users', {
                params: {
                    search: search
                }
            }).then(
                function (response) {
                    return response.data.users;
                },
                function (error) {

                }
            )
        };

        this.getStations = function (search) {
            return $http.get('/data/get-stations', {
                params: {
                    search: search
                }
            }).then(
                function (response) {
                    let stations =  response.data.stations;
                    for (let i = 0; i < stations.length; i++) {
                        stations[i].addNames = stations[i].addNames.join(', ');
                    }
                    return stations;
                },
                function (error) {

                }
            )
        };

        this.getEmployees = function (clientId, search) {
            return $http.get('/data/get-employees', {
                params: {
                    client_id: clientId,
                    search: search
                }
            }).then(
                function (response) {
                    let employees =  response.data.employees;
                    for (let i = 0; i < employees.length; i++) {
                        employees[i].str = getEmployeesStr(employees[i]);
                    }
                    return employees;
                },
                function (error) {

                }
            )
        }

        this.getPassengers = function (search) {
            return $http.get('/data/get-passengers', {
                params: {
                    search: search
                }
            }).then(
                function (response) {
                    let passengers =  response.data.passengers;
                    for (let i = 0; i < passengers.length; i++) {
                        passengers[i].str = getPassengersStr(passengers[i]);
                    }
                    return passengers;
                },
                function (error) {

                }
            )
        };

        function getEmployeesStr(p) {
            return p.last_name + ' ' + p.first_name + ' / ' + p.iin;
        }

        function getPassengersStr(p) {
            let str;

            if (p.patronymic) {
                str = p.last_name + ', ' + p.first_name + ' ' + p.patronymic;
            } else {
                str = p.last_name + ', ' + p.first_name;
            }

            str += ' / ' + p.doc_number;

            if (p.iin) {
                str += ' / ' + p.iin;
            }

            return str;
        }

    }]);

export default 'core.data';


// WEBPACK FOOTER //
// ./resources/assets/modules/core/data.service.js